import { render, staticRenderFns } from "./BankAccountsNotVerified.vue?vue&type=template&id=1f47ac1e&scoped=true&"
import script from "./BankAccountsNotVerified.vue?vue&type=script&lang=js&"
export * from "./BankAccountsNotVerified.vue?vue&type=script&lang=js&"
import style0 from "./BankAccountsNotVerified.vue?vue&type=style&index=0&id=1f47ac1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f47ac1e",
  null
  
)

export default component.exports